import * as React from 'react';
import { IconProps } from '../types';

const IcCircleNumberTwo = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <rect
      width={32}
      height={32}
      x={0.283}
      fill={props?.fill ?? '#D2464F'}
      rx={16}
    />
    <path
      fill="#fff"
      d="M13.621 18.288a54.491 54.491 0 0 0 2.142-1.862 8.865 8.865 0 0 0 1.33-1.568c.355-.541.532-1.073.532-1.596 0-.476-.112-.85-.336-1.12-.224-.27-.57-.406-1.036-.406-.466 0-.826.159-1.078.476-.252.308-.383.733-.392 1.274H12.88c.037-1.12.369-1.97.994-2.548.635-.579 1.438-.868 2.408-.868 1.064 0 1.88.285 2.45.854.57.56.854 1.302.854 2.226 0 .728-.196 1.423-.588 2.086a8.426 8.426 0 0 1-1.344 1.736 44.39 44.39 0 0 1-1.974 1.764h4.13v1.624h-6.916v-1.456l.728-.616Z"
    />
  </svg>
);

export default IcCircleNumberTwo;
